import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../app.service';
import { WarrantyTypeVM } from '../customer-contact/Models/customer-contact.model';
import { DocumentLibraryService } from '../GET_NEW_UI/services/document-library.service';

@Component({
  selector: 'app-warranty-type-setup',
  templateUrl: './warranty-type-setup.component.html',
  styleUrls: ['./warranty-type-setup.component.scss']
})
export class WarrantyTypeSetupComponent implements OnInit {

  NoOfCycles: number;
  Hours: number=0
  Days: number=0;
  warrantyTypeName: string = ""
  selectStatus: number= 1;
  warrantyList: WarrantyTypeVM[] = [];

  selectedWarantyId:number = 0;
  constructor(private _appService: AppService, private _service: DocumentLibraryService, private _notify:NotificationsService) { }

  ngOnInit() {
    this._appService.setPageTitle('Warranty Type Setup');
    this.LoadAllWarranties();
  }

  LoadAllWarranties() {
    this._service.LoadAllWarantyList().subscribe(res => {
      this.warrantyList = res;
    })
  }

  SaveWarranty() {
if(this.warrantyTypeName==""){
this._notify.error("Please Enter Warranty Type Name")
}

else if(this.Hours==0){
  this._notify.error("Please Enter Hours")
}
else if(this.Days==0){
  this._notify.error("Please Enter Days")
}
else{
  let param =new WarrantyTypeVM();
  param.NoOfCycles =this.NoOfCycles;
  param.Days=this.Days;
  param.Hours=this.Hours;
  param.Status = Number(this.selectStatus);
  param.Type = this.warrantyTypeName;
  param.ID = this.selectedWarantyId;
console.log("data___", param)
  this._service.SaveOrUpdateWarranty(param).subscribe(res=>{
    if(res==true){
      this.Reset();
      this.LoadAllWarranties();
      this._notify.success("Successfully Saved")
    }else{

    }
  })


}
 

  }

  Reset(){
    this.NoOfCycles = null;
    this.warrantyTypeName="";
    this.selectStatus = 0;
    this.selectedWarantyId = 0;
    this.Days = null;
    this.Hours=null;

  }

  RowClick(warranty:WarrantyTypeVM){
    this.warrantyTypeName = warranty.Type;
    this.Hours=warranty.Hours;
    this.Days=warranty.Days;
    this.NoOfCycles=warranty.NoOfCycles;
    this.selectStatus =warranty.Status;
    this.selectedWarantyId = warranty.ID;
  }

}
